import { useTranslation } from 'react-i18next'
import { MEETING_STATUS } from '../types'

const MAP: Record<number, { key: string; cls: string }> = {
  [MEETING_STATUS.DRAFT]: { key: 'meetings.status.draft', cls: 'mtg-badge--draft' },
  [MEETING_STATUS.PUBLISHED]: { key: 'meetings.status.published', cls: 'mtg-badge--published' },
  [MEETING_STATUS.ARCHIVED]: { key: 'meetings.status.archived', cls: 'mtg-badge--archived' },
}

/** Toplantı durumu rozeti (044): Taslak / Yayınlandı / Arşivlendi. Bilinmeyen/null → gösterilmez. */
export default function MeetingStatusBadge({ statusId }: Readonly<{ statusId: number | null }>) {
  const { t } = useTranslation()
  if (statusId == null) return null
  const cfg = MAP[statusId]
  if (!cfg) return null
  return <span className={`mtg-badge ${cfg.cls}`}>{t(cfg.key)}</span>
}
